import React from 'react';
import styled from 'styled-components';
import { palette } from 'styles/color';
import theme from 'styles/Theme';
import Typography from './Typography';

type TextFieldPropsType = {
  label?: string;
  error?: string;
  style?: React.CSSProperties;
} & React.InputHTMLAttributes<HTMLInputElement>;

/**
 * @param {string} label - input 요소의 라벨 텍스트
 * @param {string} error - input 요소의 에러 메시지
 * @param {React.InputHTMLAttributes<HTMLInputElement>} rest - HTML input Element의 기본 속성
 */
const TextField: React.FC<TextFieldPropsType> = ({ label, error, style, ...rest }) => (
  <Wrapper style={style}>
    {label && <Label htmlFor={rest.id}>{label}</Label>}
    <InputWrapper>
      <Input id={rest.id} error={error} {...rest} />
      {error && (
        <Typography component="span" size="12px" height="15px" weight={400} color={palette.red}>
          {error}
        </Typography>
      )}
    </InputWrapper>
  </Wrapper>
);

export default TextField;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

const Label = styled.label`
  font-size: 14px;
  line-height: 16px;
  color: ${palette.gray[800]};
`;

const Input = styled.input<{ error?: string }>`
  padding: 10px 12px;
  border-radius: 8px;
  font-size: 12px;
  line-height: 18px;
  background: ${palette.gray[100]};
  outline: none;
  border: 1px solid ${({ error }) => (error ? theme.colors.error : 'transparent')};
  box-shadow: none;

  &:focus {
    border: 1px solid ${palette.gray[800]};
  }

  &::placeholder {
    color: ${palette.gray[400]};
  }
`;

const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;
